const DEFAULT_PAGE = 1;
const DEFAULT_ITEMS_PER_PAGE = 15;

function normalizePage(value) {
    const n = parseInt(String(value ?? ''), 10);
    return Number.isFinite(n) && n > 0 ? n : DEFAULT_PAGE;
}

function normalizeItemsPerPage(value) {
    const n = parseInt(String(value ?? ''), 10);
    // Синхрон с backend Paginator::get(): take < 0 = без пагинации («все»).
    if (Number.isFinite(n) && n < 0) {
        return n;
    }
    return Number.isFinite(n) && n > 0 ? n : DEFAULT_ITEMS_PER_PAGE;
}

export default {
    methods: {
        /**
         * Удаляет sort_by/sort_desc, если в таблице нет активной колонки сортировки.
         * Нужно при merge {...oldQuery, ...optionsToQuery}: иначе старый sort_desc остаётся
         * в query и replaceRoute крутится sort_desc=0/1 (Склад и др.).
         */
        stripInactiveTableSortQuery(obj) {
            if (!obj || typeof obj !== 'object') {
                return;
            }
            delete obj.sort_by;
            delete obj.sort_desc;
        },

        setQueryString(searchParams) {
            const params = {};
            Object.keys(searchParams).forEach(key => {
                const value = searchParams[key];
                if (value === undefined || value === null || value === "") {
                    // Пропускаем пустые значения
                    return;
                } else if (Array.isArray(value)) {
                    // Обрабатываем массивы - объединяем через запятую
                    if (value.length > 0) {
                        params[key] = value.join(',');
                    }
                    // Если массив пустой, НЕ добавляем параметр в URL
                    // Это позволяет различать "параметр не установлен" и "параметр явно очищен"
                } else if (value === true) {
                    params[key] = 1;
                } else if (value === false) {
                    params[key] = 0;
                } else {
                    params[key] = value;
                }
            });
            return new URLSearchParams(params).toString();
        },
        optionsToQuery(opts) {
            const sort_by = opts.sortBy && opts.sortBy[0];
            const hasSort = !!sort_by;
            // Без колон сортировки Vuetify всё равно шлёт sortDesc ([true]/[false]/[]).
            // Если писать sort_desc в query без sort_by — readRoute и таблица спорят (1↔0).
            // page / take: NaN или 0 дают «-14–0 из N» в футере v-data-table (см. normalizePage).
            return {
                page: normalizePage(opts.page),
                take: normalizeItemsPerPage(opts.itemsPerPage),
                sort_by: hasSort ? sort_by : undefined,
                sort_desc:
                    hasSort && opts.sortDesc && opts.sortDesc.length
                        ? opts.sortDesc[0]
                        : undefined,
            };
        },
        queryToOptions(query) {
            const sort = [query.sort_by].filter(x => x);
            // Без активной колонки сортировки sortDesc должен быть пустым: иначе Vuetify
            // (sortBy: []) шлёт sortDesc []/[false], мы кладём sort_desc в URL, а при чтении
            // мерж подставлял [true] по умолчанию → бесконечный replaceRoute (sort_desc 0↔1).
            const hasSort = sort.length > 0;
            const desc = hasSort
                ? [query.sort_desc != null && String(query.sort_desc) !== ''
                    ? !!parseInt(String(query.sort_desc), 10)
                    : true]
                : [];
            return {
                page: normalizePage(query.page),
                itemsPerPage: normalizeItemsPerPage(query.take),
                sortBy: sort,
                sortDesc: desc,
            };
        },
    }
}